module.exports = __webpack_public_path__ + "img/page-01.5d2a7950.png";